import React from "react";
import "./MuiDateInput.css";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

const toDayjs = (value) => {
  if (!value) return null;
  const d = dayjs(value);
  return d.isValid() ? d : null;
};

const MuiDateInput = ({
  heading,
  value,
  onChange,
  readOnly,
  minDate,
  maxDate,
  height = "45",
  error,
  disabled,
}) => {
  const handleChange = (date) => {
    if (date && date.isValid()) {
      onChange(date.toDate());
    } else {
      onChange(null);
    }
  };

  return (
    <div className="muiInputDateContainer">
      {heading && <div className="inputextElem">{heading}</div>}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          value={toDayjs(value)}
          onChange={handleChange}
          format="DD-MMM-YYYY"
          disabled={disabled}
          readOnly={readOnly}
          minDate={toDayjs(minDate)}
          maxDate={toDayjs(maxDate)}
          slotProps={{
            textField: {
              fullWidth: true,
              placeholder: "DD-MMM-YYYY",
              error: Boolean(error),
              sx: {
                "& .MuiOutlinedInput-root": {
                  height: `${height}px`,
                  borderRadius: "8px",
                  backgroundColor: "var(--white-background)",
                  fontSize: "12px",
                  fontWeight: 500,
                  color: "var(--fifth-color-text)",
                  "& fieldset": {
                    borderColor: "#e2e2e5",
                  },
                  "&:hover fieldset": {
                    borderColor: "#e2e2e5",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "var(--primary-color-text)",
                    borderWidth: "1px",
                  },
                  "&.Mui-error fieldset": {
                    borderColor: "var(--warning-text)",
                  },
                  "& .MuiSvgIcon-root": {
                    color: "var(--fifth-color-text)",
                  },
                },
                "& .MuiOutlinedInput-input": {
                  padding: "0 12px",
                  color: "var(--fifth-color-text)",
                  caretColor: "var(--primary-color-text)",
                },
                "& .MuiOutlinedInput-input::placeholder": {
                  color: "var(--fifth-color-text)",
                  opacity: 1,
                  fontSize: "12px",
                  fontWeight: 500,
                },
              },
            },
            popper: {
              sx: {
                zIndex: 9999,
                "& .MuiPickersDay-root.Mui-selected": {
                  backgroundColor: "var(--primary-color-text)",
                  color: "#fff",
                },
                "& .MuiPickersDay-root.Mui-selected:hover": {
                  backgroundColor: "var(--primary-color-text)",
                },
                "& .MuiPickersDay-root.Mui-selected:focus": {
                  backgroundColor: "var(--primary-color-text)",
                },
                "& .MuiPickersDay-root:not(.Mui-selected)": {
                  "&:focus": {
                    backgroundColor: "transparent",
                  },
                },
                "& .MuiPickersDay-root.MuiPickersDay-today:not(.Mui-selected)": {
                  borderColor: "var(--primary-color-text)",
                },
                "& .MuiPickersYear-yearButton.Mui-selected": {
                  backgroundColor: "var(--primary-color-text)",
                  color: "#fff",
                },
                "& .MuiPickersMonth-monthButton.Mui-selected": {
                  backgroundColor: "var(--primary-color-text)",
                  color: "#fff",
                },
                "& .MuiPickersCalendarHeader-switchViewButton, & .MuiPickersArrowSwitcher-button":
                  {
                    color: "var(--primary-color-text)",
                  },
              },
            },
          }}
        />
      </LocalizationProvider>
      {error && <div className="muiDateErrorHeading">{error}</div>}
    </div>
  );
};

export default MuiDateInput;
